var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalDebit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#FEE7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 11H21.875V11.75H18.125V11Z",
    fill: "#EB3949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 12.875H14.375V15.125H17.75V12.875ZM17 14.375H15.125V13.625H17V14.375Z",
    fill: "#EB3949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13.625H21.875V14.375H18.5V13.625Z",
    fill: "#EB3949"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 15.875H14.375V18.125H17.75V15.875ZM17 17.375H15.125V16.625H17V17.375Z",
    fill: "#EB3949"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 16.625H21.875V17.375H18.5V16.625Z",
    fill: "#EB3949"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 18.875H14.375V21.125H17.75V18.875ZM17 20.375H15.125V19.625H17V20.375Z",
    fill: "#EB3949"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19.625H21.875V20.375H18.5V19.625Z",
    fill: "#EB3949"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 21.875H14.375V24.125H17.75V21.875ZM17 23.375H15.125V22.625H17V23.375Z",
    fill: "#EB3949"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22.625H21.875V23.375H18.5V22.625Z",
    fill: "#EB3949"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 24.875H25.625V25.625H14.375V24.875Z",
    fill: "#EB3949"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 26.375H17V27.125H14.375V26.375Z",
    fill: "#EB3949"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 26.375H22.25V27.125H18.125V26.375Z",
    fill: "#EB3949"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 13.625H23.75V14.375H22.625V13.625Z",
    fill: "#EB3949"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 13.625H25.625V14.375H24.5V13.625Z",
    fill: "#EB3949"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 16.625H23.75V17.375H22.625V16.625Z",
    fill: "#EB3949"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.625H25.625V17.375H24.5V16.625Z",
    fill: "#EB3949"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 19.625H23.75V20.375H22.625V19.625Z",
    fill: "#EB3949"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19.625H25.625V20.375H24.5V19.625Z",
    fill: "#EB3949"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 22.625H23.75V23.375H22.625V22.625Z",
    fill: "#EB3949"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 22.625H25.625V23.375H24.5V22.625Z",
    fill: "#EB3949"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 8.75H13.25C12.6125 8.75 12.125 9.2375 12.125 9.875V30.125C12.125 30.7625 12.6125 31.25 13.25 31.25H24.65L27.875 27.65V9.875C27.875 9.2375 27.3875 8.75 26.75 8.75ZM27.125 27.35L24.875 29.8625V28.25C24.875 28.025 25.025 27.875 25.25 27.875H26V27.125H25.25C24.6125 27.125 24.125 27.6125 24.125 28.25V30.5H13.25C13.025 30.5 12.875 30.35 12.875 30.125V9.875C12.875 9.65 13.025 9.5 13.25 9.5H26.75C26.975 9.5 27.125 9.65 27.125 9.875V27.35Z",
    fill: "#EB3949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDebit);
export default __webpack_public_path__ + "static/media/total_debit.42d72696503531651ff018b9f99f2d03.svg";
export { ForwardRef as ReactComponent };